import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

/**
 * Invisible padding above the card keeps the pointer inside the hover target
 * while moving from the trigger into the menu (no dead-zone gap).
 * The visual card is the `data-menu-card` child — it owns the open animation.
 */
export const HoverMenuRoot = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'originX',
})<{ originX?: 'left' | 'right' | 'center' }>(({ originX = 'left' }) => ({
  paddingTop: 'var(--mui-spacing)',
  pointerEvents: 'none',
  '& > [data-menu-card]': {
    opacity: 0,
    transform: 'translateY(-10px) scale(0.96)',
    transformOrigin: `top ${originX}`,
    transition: 'opacity 200ms cubic-bezier(0.16, 1, 0.3, 1), transform 240ms cubic-bezier(0.16, 1, 0.3, 1)',
    willChange: 'opacity, transform',
  },
  '&[data-open="true"]': {
    pointerEvents: 'auto',
    '& > [data-menu-card]': {
      opacity: 1,
      transform: 'translateY(0) scale(1)',
    },
  },
  '@media (prefers-reduced-motion: reduce)': {
    '& > [data-menu-card]': {
      transition: 'none',
    },
  },
}));

export const hoverMenuCardBaseSx = {
  backgroundColor: 'var(--mui-palette-background-paper-elevation-3)',
  boxShadow: 'var(--mui-shadows-1)',
  borderRadius: 'var(--mui-shape-borderRadius)',
  overflow: 'hidden',
} as const;
